/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Tue Mar 12 2024
 **/

import { useAtomCallback } from "jotai/utils";

import { JotaiStore } from "@/frameworks/libraries/commons";
import { useEventHandlers } from "@rfice/eventhandler";

import { EventID } from "@/frameworks/core/commons";
import {
	OpenPeopleDetailIsMeAtom,
	OpenPeopleDetailUserData,
	OpenPeopleDetailIsLoadedAtom,
	OpenPeopleDetailUserID
} from "./atom";
import { usePeople } from "@/frameworks/core/API";
import { usePeopleListActions } from "@/frameworks/core/hooks";

export default function OpenPeopleDetailProvider() {
	const peopleAPI = usePeople();
	const { getPeopleList } = usePeopleListActions();
	const handler = useAtomCallback(
		async (_, set, userData: WebServices.People.List.User, isMe: boolean) => {
			set(OpenPeopleDetailIsLoadedAtom, true);
			const { data } = await getPeopleList();
			const groupsMap = new Map(data);
			const arrayGroups = [...groupsMap];
			const groupId = arrayGroups.find((group) => {
				const usersMap = new Map(group[1].users);
				const arrayUsers = [...usersMap];
				return arrayUsers.find((user) => user[0] === userData.userId);
			});
			const userInfo = userData.groupId ? userData : Object.assign(userData, { groupId: groupId?.[1].groupId });
			set(OpenPeopleDetailIsMeAtom, isMe), set(OpenPeopleDetailUserData, userInfo);
			set(OpenPeopleDetailIsLoadedAtom, false);
			set(OpenPeopleDetailUserID, userInfo.userId);
		},
		{
			store: JotaiStore
		}
	);

	useEventHandlers(
		{
			[EventID.OPEN_PEOPLEDETAIL_PANEL]: handler,
			[EventID.onGroupCommand]: (type: string) => {
				switch (type) {
					case "leave":
					case "delete":
						peopleAPI.list.execute();
						break;
					default: {
						break;
					}
				}
			}
		},
		[]
	);
	return null;
}
